import { render, staticRenderFns } from "./ListSelections.vue?vue&type=template&id=4f720acf&scoped=true"
import script from "./ListSelections.vue?vue&type=script&lang=js"
export * from "./ListSelections.vue?vue&type=script&lang=js"
import style0 from "./ListSelections.vue?vue&type=style&index=0&id=4f720acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f720acf",
  null
  
)

export default component.exports